import { type AnyString } from "../../../types/utility/AnyString";
import { type ValueOf } from "../../../types/utility/ValueOf";

export const providerAPIs = {
  CHAT_COMPLETIONS: "chat_completions",
  RESPONSES: "responses",
} as const;

export type ProviderAPI = ValueOf<typeof providerAPIs> | AnyString;
